export default __webpack_public_path__ + "static/media/objetivo-1.66ae14e9.svg";